export const theme = {
    borderRadius: {
        '4xl': '1.5rem',
        '5xl': '1.75rem',
        '6xl': '2rem',
        '7xl': '2.25rem',
        '8xl': '2.5rem',
        full: '12.5rem',
        l: '0.625rem',
        m: '0.5rem',
        s: '0.375rem',
        xl: '0.75rem',
        xs: '0.25rem',
        xxl: '1rem',
        xxs: '0.125rem',
        xxxl: '1.25rem',
    },
    colors: {
        black: {
            100: '#caccd0',
            200: '#b1b4b9',
            300: '#989da2',
            400: '#80858a',
            50: '#e2e3e8',
            500: '#676d73',
            600: '#4e565c',
            700: '#353e45',
            800: '#1d272d',
            900: '#040f16',
        },
        error: {
            100: '#FEE4E2',
            200: '#FECDCA',
            25: '#FFFBFA',
            300: '#FDA29B',
            400: '#F97066',
            50: '#FEF3F2',
            500: '#F04438',
            600: '#D92D20',
            700: '#B42318',
            800: '#912018',
            900: '#7A271A',
            950: '#55160C',
        },
        gray: {
            100: '#f6f6f7',
            200: '#f1f1f0',
            300: '#e7e7e7',
            400: '#dadad8',
            50: '#f9f9fc',
            500: '#c7c7c5',
            600: '#b2b2b0',
            700: '#9a9a98',
            800: '#6e6e6c',
            900: '#505052',
        },
        info: {
            100: '#B3D4FF',
            200: '#0066FF',
            25: '#F5F9FF',
            300: '#0052D6',
            400: '#003DAD',
            50: '#E6F0FF',
            500: '#002984',
            600: '#001F6B',
            700: '#001552',
            800: '#000D3D',
            900: '#00002E',
            950: '#00001A',
        },
        orange: {
            100: '#FFE2D6',
            200: '#FFD3C2',
            300: '#FFC5AD',
            400: '#FFB699',
            50: '#FFF0EB',
            500: '#FF9970',
            600: '#FF8A5C',
            700: '#FF7B47',
            800: '#FF6A2D',
            900: '#FF500A',
        },
        success: {
            100: '#9BD1A0',
            200: '#6BB572',
            25: '#F0F9F1',
            300: '#3D9A47',
            400: '#359142',
            50: '#BCDFC0',
            500: '#018B02',
            600: '#016A02',
            700: '#015201',
            800: '#003A01',
            900: '#002300',
            950: '#001200',
        },
        warning: {
            100: '#FEF0C7',
            200: '#FEDF89',
            25: '#FFFCF5',
            300: '#FEC84B',
            400: '#FDB022',
            50: '#FFFAEB',
            500: '#F79009',
            600: '#DC6803',
            700: '#B54708',
            800: '#93370D',
            900: '#7A2E0E',
            950: '#4E1D09',
        },
        white: {
            0: '#ffffff',
            200: '#fbfbff',
        },
    },

    shadows: {
        large: 'inset 1px 1px 1px rgba(251, 251, 255, 1), inset -1px -1px 1px rgba(0, 0, 0, 0.15), 0.44px 0.44px 0.63px rgba(0, 0, 0, 0.25), 1.21px 1.21px 1.71px rgba(0, 0, 0, 0.25), 2.66px 2.66px 3.76px rgba(0, 0, 0, 0.25), 5.9px 5.9px 8.35px rgba(0, 0, 0, 0.19), 10px 10px 21.21px rgba(0, 0, 0, 0.05), -0.5px -0.5px 0px rgba(0, 0, 0, 0.05)',
        medium: 'inset 1px 1px 1px rgba(251, 251, 255, 1), inset -0.5px -0.5px 1px rgba(0, 0, 0, 0.07), 0.22px 0.22px 0.31px rgba(0, 0, 0, 0.13), 0.3px 0.3px 0.86px rgba(0, 0, 0, 0.13), 1.33px 1.33px 1.88px rgba(0, 0, 0, 0.11), 2.95px 2.95px 4.18px rgba(0, 0, 0, 0.1), 5px 5px 10.6px rgba(0, 0, 0, 0.05), -0.32px -0.32px 0px rgba(0, 0, 0, 0.05)',
        small: 'inset 1px 1px 1px rgba(251, 251, 255, 0.75), inset -0.5px -0.5px 1px rgba(0, 0, 0, 0.07), 0px 0px 1px rgba(66, 66, 66, 0), 0px 0px 1px rgba(66, 66, 66, 0.05), 0px 0px 1px rgba(66, 66, 66, 0.12), 0px 0px 1px rgba(66, 66, 66, 0.18), 0px 0px 0px rgba(0, 0, 0, 0), -0.25px -0.25px 0px rgba(0, 0, 0, 0.05)',
    },

    spacing: {
        '10xl': '2.75rem',
        '11xl': '3rem',
        '12xl': '3.5rem',
        '13xl': '4rem',
        '3xl': '1.25rem',
        '4xl': '1.5rem',
        '5xl': '1.75rem',
        '6xl': '2rem',
        '7xl': '2.25rem',
        '8xl': '2.5rem',
        l: '0.625rem',
        m: '0.5rem',
        s: '0.375rem',
        xl: '0.75rem',
        xs: '0.25rem',
        xxl: '1rem',
        xxs: '0.125rem',
    },

    typography: {
        body: {
            L: {
                medium: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '1.125rem',
                    fontWeight: '500',
                    lineHeight: '1.625rem',
                },
                regular: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '1.125rem',
                    fontWeight: '400',
                    lineHeight: '1.625rem',
                },
                semibold: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '1.125rem',
                    fontWeight: '600',
                    lineHeight: '1.625rem',
                },
            },
            M: {
                medium: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '1rem',
                    fontWeight: '500',
                    letterSpacing: '-0.02rem',
                    lineHeight: '1.5rem',
                },
                regular: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '1rem',
                    fontWeight: '400',
                    letterSpacing: '-0.02rem',
                    lineHeight: '1.5rem',
                },
                semibold: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '1rem',
                    fontWeight: '600',
                    letterSpacing: '-0.02rem',
                    lineHeight: '1.5rem',
                },
            },
            S: {
                medium: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    letterSpacing: '-0.0175rem',
                    lineHeight: '1.25rem',
                },
                regular: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.875rem',
                    fontWeight: '400',
                    letterSpacing: '-0.0175rem',
                    lineHeight: '1.25rem',
                },
                semibold: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    letterSpacing: '-0.0175rem',
                    lineHeight: '1.25rem',
                },
            },
            XS: {
                medium: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.813rem',
                    fontWeight: '500',
                    lineHeight: '1rem',
                },
                regular: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.813rem',
                    fontWeight: '400',
                    lineHeight: '1rem',
                },
                semibold: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.813rem',
                    fontWeight: '600',
                    lineHeight: '1rem',
                },
            },
            XXS: {
                medium: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                    lineHeight: '1rem',
                },
                regular: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.75rem',
                    fontWeight: '400',
                    lineHeight: '1rem',
                },
                semibold: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.75rem',
                    fontWeight: '600',
                    lineHeight: '1rem',
                },
            },
            XXXS: {
                medium: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.625rem',
                    fontWeight: '500',
                    lineHeight: '0.75rem',
                },
                regular: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.625rem',
                    fontWeight: '400',
                    lineHeight: '0.75rem',
                },
                semibold: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.625rem',
                    fontWeight: '600',
                    lineHeight: '0.75rem',
                },
            },
        },
        caption: {
            S: {
                bold: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.75rem',
                    fontWeight: '700',
                    lineHeight: '0.875rem',
                    textTransform: 'uppercase',
                },
                medium: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                    lineHeight: '0.875rem',
                    textTransform: 'uppercase',
                },
                regular: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.75rem',
                    fontWeight: '400',
                    lineHeight: '0.875rem',
                    textTransform: 'uppercase',
                },
                semibold: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.75rem',
                    fontWeight: '600',
                    lineHeight: '0.875rem',
                    textTransform: 'uppercase',
                },
            },
            XS: {
                bold: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.625rem',
                    fontWeight: '700',
                    lineHeight: '0.75rem',
                    textTransform: 'uppercase',
                },
                medium: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.625rem',
                    fontWeight: '500',
                    lineHeight: '0.75rem',
                    textTransform: 'uppercase',
                },
                regular: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.625rem',
                    fontWeight: '400',
                    lineHeight: '0.75rem',
                    textTransform: 'uppercase',
                },
                semibold: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '0.625rem',
                    fontWeight: '600',
                    lineHeight: '0.75rem',
                    textTransform: 'uppercase',
                },
            },
        },
        headline: {
            h1: {
                medium: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '2.5rem',
                    fontWeight: '500',
                    letterSpacing: '-0.075rem',
                    lineHeight: '3rem',
                },
                regular: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '2.5rem',
                    fontWeight: '400',
                    letterSpacing: '-0.075rem',
                    lineHeight: '3rem',
                },
            },
            h2: {
                medium: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '2rem',
                    fontWeight: '500',
                    letterSpacing: '0.075rem',
                    lineHeight: '2.5rem',
                },
                regular: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '2rem',
                    fontWeight: '400',
                    letterSpacing: '0.075rem',
                    lineHeight: '2.5rem',
                },
            },
            h3: {
                medium: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '1.5rem',
                    fontWeight: '400',
                    letterSpacing: '0.075rem',
                    lineHeight: '2rem',
                },
                regular: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '1.5rem',
                    fontWeight: '400',
                    letterSpacing: '0.075rem',
                    lineHeight: '2rem',
                },
            },
            h4: {
                medium: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '1.375rem',
                    fontWeight: '500',
                    letterSpacing: '-0.0275rem',
                    lineHeight: '2rem',
                },
                regular: {
                    fontFamily: 'FT Regola Neue',
                    fontSize: '1.375rem',
                    fontWeight: '400',
                    letterSpacing: '-0.0275rem',
                    lineHeight: '2rem',
                },
            },
        },
    },
};

export type CobrainerTheme = typeof theme;
